import { aboutContent } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              {aboutContent.title}
            </h2>
          </div>

          <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-10">
            <div className="flex flex-col md:flex-row gap-8 items-start">
              <div className="w-16 h-16 md:w-20 md:h-20 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-newspaper-line text-2xl md:text-3xl"></i>
              </div>
              <div className="space-y-4">
                {aboutContent.paragraphs.map((p, i) => (
                  <p key={i} className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    {p}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}